var React = require('react');

function CarouselNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 33L12.46 17.72C12.78 17.2933 12.78 16.7067 12.46 16.28L0.999999 0.999999","stroke":"#CCCCCC","strokeWidth":"1.5","strokeLinecap":"round"}));
}

CarouselNext.defaultProps = {"width":"12","height":"32","viewBox":"0 0 14 34","fill":"none"};

module.exports = CarouselNext;

CarouselNext.default = CarouselNext;
